<!-- Header Section -->
<header class="header">
    <div class="logo">Kiko VPN</div>
    <nav class="navigation">
        <a href="/home">Home</a>
        <a href="/downloads">Downloads</a>
        <a href="/privacy">Privacy</a>
        <a href="/terms">Terms</a>
        <a href="/reseller">Reseller</a>
        <a href="/faq">Faq</a>
        <a href="/support">Support</a>
        <a href="/about">About Us</a>
    </nav>
</header>
<div class="faq-container">
    <h2>Frequently Asked Questions</h2>
    <div class="faq-list">
        <div *ngFor="let faq of faqs" class="faq-item">
            <div class="faq-question" (click)="faq.open = !faq.open">
                <h3>{{ faq.question }}</h3>
                <img width="20px" height="20px" [src]="faq.open ? 'assets/icons/icon_arrow_up.png' : 'assets/icons/icon_arrow_down.png'" alt="chevron icon" class="faq-icon"/>
            </div>
            <div class="faq-answer" *ngIf="faq.open">
                <p>{{ faq.answer }}</p>
            </div>
        </div>
    </div>
</div>